import { motion } from "framer-motion";
import { Home, Building2, Store, Sparkles, Sofa, Trees } from "lucide-react";

const sectors = [
  { icon: Building2, label: "Daire" },
  { icon: Home, label: "Villa" },
  { icon: Sofa, label: "Müstakil Ev" },
  { icon: Store, label: "Mağaza" },
  { icon: Sparkles, label: "Showroom" },
  { icon: Trees, label: "Yazlık" },
];

export const Trust = () => {
  return (
    <section data-testid="trust-section" className="py-16 sm:py-20 bg-white border-b border-zinc-200">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="text-xs tracking-[0.25em] uppercase font-bold text-zinc-500 mb-8 flex items-center gap-3">
          <span className="w-8 h-px bg-zinc-950" />
          01 — Hizmet Verdiğimiz Alanlar
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-px bg-zinc-200">
          {sectors.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.06 }}
                className="bg-white p-6 sm:p-8 flex flex-col items-start gap-4 hover:bg-zinc-50 transition-colors"
                data-testid={`sector-${s.label.toLowerCase()}`}
              >
                <Icon size={28} strokeWidth={1.5} className="text-zinc-950" />
                <span className="font-display font-bold text-base sm:text-lg text-zinc-950">
                  {s.label}
                </span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
